// Home page for each signed-in role; roles without one stay on the public website.
export const ROLE_HOME = {
  super_admin: '/admin',
  institute_admin: '/institute-panel',
  admin: '/institute-panel',
  counselor: '/institute-panel/crm',
  receptionist: '/institute-panel/crm',
  accountant: '/institute-panel/fees',
  hr: '/institute-panel/hrms/employees',
  academic_coordinator: '/institute-panel/batches',
  exam_incharge: '/institute-panel/exams',
  librarian: '/institute-panel/library',
  hostel_warden: '/institute-panel/hostel',
  transport_incharge: '/institute-panel/transport',
  teacher: '/teacher',
  staff: '/institute-panel',
  student: '/student',
  parent: '/parent',
};
